import { useEffect, useState } from "react";

const useDebounce = (value, time, eqFunc) => {

  const isEq = eqFunc || ((a, b) => a === b);
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    let to;
    if (!isEq(debouncedValue, value)) {
      to = setTimeout(() => setDebouncedValue(value), time);
    }
    return () => to ? clearTimeout(to) : null;
  }, [value, debouncedValue, time, eqFunc]);

  return debouncedValue;
};

export default useDebounce;



// WEBPACK FOOTER //
// ./webAdmin/hooks/useDebounce.js